export default __webpack_public_path__ + "static/media/2times_blue.1de9cb93.svg";